export const PERMISSION_STATEMENTS = {
  organization: ["update", "delete"],
  member: ["create", "update", "delete"],
  invitation: ["create", "cancel"],
  team: ["create", "update", "delete"],
  ac: ["create", "read", "update", "delete"],
  basic: ["manage"],
  shop: ["read"],
  shopifyWebhooks: ["delete"],
  sensitiveData: ["read"],
  metrics: ["read"],
  experiments: ["read", "write"],
  aiDiscovery: ["read", "write"],
  billing: ["read"],
  aiChat: ["read", "write"],
  sections: ["read", "write"],
  buyBoxes: ["read", "write"],
  figma: ["read", "write"],
  googleAds: ["read", "write"],
  mediaSources: ["read", "write"],
  messaging: ["read", "write"],
  funnels: ["read", "write", "comment"],
  smartLinks: ["read", "write"],
  roadmap: ["read", "write"],
  lpInspiration: ["read", "write"],
  systemConfig: ["read", "write"],
} as const;

export type PermissionStatement = typeof PERMISSION_STATEMENTS;
export type PermissionKey = keyof PermissionStatement;

type PermissionArrayForKey<K extends PermissionKey> = PermissionStatement[K] extends readonly (infer Action)[]
  ? Action[]
  : never;

export type Permissions = {
  readonly [K in PermissionKey]?: PermissionArrayForKey<K>;
};

export type McpPermissions = Pick<Permissions, "shop" | "metrics" | "funnels" | "smartLinks" | "experiments">;
